import axios from "axios";

export type BtcNetwork = "mainnet" | "testnet";
export const BTC_NETWORK: BtcNetwork =
  (process.env.REACT_APP_BTC_NETWORK as BtcNetwork) || "testnet";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3003";
export const APIClient = axios.create({
  baseURL: `${API_URL}/v2/ord/btc`,
});
export const AdminAPIClient = axios.create({
  baseURL: `${API_URL}/v2/ord/admin/btc`,
});
